module.exports = __webpack_public_path__ + "img/0121.4d33b8a1.png";